/* eslint-disable react/no-unknown-property */
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { RAF_BANNER, RAF_MOBILE_BANNER } from '../../config/constants/images';
import {
  CREDIT_TWO_HUNDRED,
  GET,
  INVITE_FRIENDS,
  MINI_MENU_RAF,
  REFER_YOUR_FRIENDS,
  UP_TO,
} from '../../config/text/text';
import { trackEvent } from '../../helpers/analytics';
import { redirectToRoute } from '../../helpers/url';
import ThemeContext from '../../providers/ThemeProvider';
import PrimaryButton from '../_generic/button/PrimaryButton';

const ReferFriendBanner = ({ withButton }) => {
  const theme = useContext(ThemeContext);
  const router = useRouter();

  return (
    <>
      <div className="banner">
        <div className="banner-wrap">
          <div className="banner--text">
            <span className="text--bold">{REFER_YOUR_FRIENDS}</span>{' '}
            <span className="text--md">
              {GET} {UP_TO}
            </span>
            <span className="text--bold">{CREDIT_TWO_HUNDRED}</span>{' '}
            {withButton && (
              <div className="invite-friends-btn">
                <PrimaryButton
                  className="fit-content size-medium size-small-mobile-only"
                  onClick={() => {
                    trackEvent('raf: post purchase banner click');
                    redirectToRoute(MINI_MENU_RAF, router);
                  }}
                >
                  {INVITE_FRIENDS}
                </PrimaryButton>
              </div>
            )}
          </div>
        </div>
      </div>
      <style jsx>{`
        .banner {
          width: 100%;
          height: fit-content;
          background-color: ${theme.colors.referfriendbanner};
          background: no-repeat url(${RAF_MOBILE_BANNER})
            ${theme.colors.referfriendbanner};
          background-size: ${withButton ? '480px' : '520px'};
          background-position: ${withButton ? '50% -20px' : '38% -20px'};
          text-align: center;
        }
        .banner-wrap {
          width: 100%;
          max-width: ${withButton ? '250px' : '280px'};
          margin: auto;
        }
        .banner--text {
          font-size: ${withButton ? '16px' : '18px'};
          max-width: fit-content;
          display: flex;
          flex-direction: column;
          align-items: center;
          text-transform: uppercase;
          padding: ${withButton ? '1rem 0' : '1.5rem'};
        }
        .banner--text > span {
          line-height: 15px;
        }
        .invite-friends-btn {
          margin-top: 0.2rem;
        }
        .text--md {
          font-size: ${withButton ? '12px' : '14px'};
        }
        .text--bold {
          font-weight: 600;
        }
        :global(.raf-button) {
          margin-top: 8px;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .banner {
            background: no-repeat url(${RAF_BANNER})
              ${theme.colors.referfriendbanner};
            background-size: ${withButton ? '760px' : '680px'};
            background-position: ${withButton ? '40% -26px' : 'center'};
          }
          .banner-wrap {
            max-width: 390px;
          }
          .banner--text {
            font-size: 26px;
            padding: 1.5rem;
          }
          .invite-friends-btn {
            margin-top: 0.5rem;
          }
          .banner--text > span {
            line-height: 22px;
          }
          .text--md {
            font-size: 18px;
          }
        }
      `}</style>
    </>
  );
};

ReferFriendBanner.propTypes = {
  withButton: PropTypes.bool,
};

export default ReferFriendBanner;
